import { toSkillsetNames } from './to-skillset-names';

const toProfyleSkillsetNames = (profyle: { result: { quiz: { skillsets: { name: string }[] } } }) =>
  toSkillsetNames(profyle.result.quiz.skillsets);

export { toProfyleSkillsetNames };
